import withLazyLoad from 'bv-lazy-load';

export default withLazyLoad()('seo');
